
<template>
    <v-dialog
    v-model="adDialog"                
    
    persistent
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                {{this.adDialogData.titulo}}    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                {{this.adDialogData.contenido}}
                <v-img v-if="this.adDialogData.imagen" :src="this.adDialogData.imagen"></v-img>
            </v-card-text>                        
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                flat
                @click="closeDialog()"
            >
                Cerrar
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'adDialog',
    data () {
      return {             
         
      }
    },
    methods:{                
        closeDialog(){
            this.adDialogData.visto = true;
            this.$store.commit('setAdDialogData', this.adDialogData)
            this.adDialog = false;
        }
    },
    computed: {     
        adDialog:{
            get(){
                return this.$store.state.adDialog;
            },
            set(value){
                this.$store.commit('setAdDialog', value)
            }
        }, 
        adDialogData: {
            get(){
                return this.$store.state.adDialogData;
            }
        }
    } 
}
</script>

